// extracted by mini-css-extract-plugin
export default {"container":"DrawingPage_container__vZop2"};